module.exports = __webpack_public_path__ + "84b0176889b814c177023040b964ac6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/accenture_2022_chart.png
// module id = 1621
// module chunks = 0